import { render, staticRenderFns } from "./AdminPromos.vue?vue&type=template&id=b2770ffe&"
import script from "./AdminPromos.vue?vue&type=script&lang=js&"
export * from "./AdminPromos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports